"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'SummaryPopup',
  props: {
    dataList: Array
  }
};
exports.default = _default;